import React from 'react'
import SnackDetails from '../SnackDetails'
import '../styles/show.css'

export default function Show() {
  return (
    <div className='shows'>
    <SnackDetails/>
  </div>
 
  )
}
